<template>
  <div class="page">
    <div class="left_box">
      <div class="block">
        <div class="group01">
          <img src="../../src/assets/new/logo/newzrlogo.png" alt="" class="img01" @click="toPath('/aggregate','')">
          <!-- <div class="text01">{{ homeType == '1' ? '供应商后台' : '企业-工作台' }}</div> -->
        </div>
        <div class="group02">
          <el-aside width="250px" style="background-color: #fff;height:100%;position: fixed;">
            <el-menu :default-active="activeNum" class="el-menu-vertical-demo" style="font-size: 18px;"
              @open="handleOpen" @close="handleClose" @select="select">
              <el-menu-item index="1">
                <span slot="title">概览</span>
              </el-menu-item>
              <!-- <el-menu-item index="2">
                <span slot="title">工作台</span>
              </el-menu-item> -->
              <!--<el-menu-item index="3" v-if="homeType == '0'">
                <span slot="title">已购管理</span>
              </el-menu-item>-->
              <el-menu-item index="5" v-if="homeType == '0'">
                <span slot="title">应用管理</span>
              </el-menu-item>
              <el-menu-item index="8"> 
                <span slot="title">我的订单</span>
              </el-menu-item>
              <!--<el-menu-item index="4" v-if="homeType == '0'">
                <span slot="title">我的收藏</span>
              </el-menu-item>-->
              <el-submenu index="2" v-if="homeType == '0'">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span>组织管理</span>
                </template>
                <el-menu-item index="2-1">组织信息</el-menu-item>
                <el-menu-item index="2-2">资格认证</el-menu-item>
                <el-menu-item index="2-3">角色管理</el-menu-item>
                <el-menu-item index="2-4">架构管理</el-menu-item>
              </el-submenu>
              <el-submenu index="3" v-if="homeType == '0'">
                <template slot="title">
                  <i class="el-icon-s-promotion"></i>
                  <span>应用交付</span>
                </template>
                <el-menu-item index="3-1">个人应用交付</el-menu-item>
                <el-menu-item index="3-2">企业应用交付</el-menu-item>
              </el-submenu>
              <el-submenu index="6"
                v-if="homeType == '1'&&supplierInfo != null && supplierInfo!='' && supplierInfo.supplierStatus == '0'">
                <template slot="title">应用管理</template>
                <el-menu-item index="6-1">应用管理</el-menu-item>
              </el-submenu>
              <el-menu-item index="8" v-if="homeType == '1'&&supplierInfo != null && supplierInfo!='' && supplierInfo.supplierStatus == '0'">
                <span slot="title">销售订单</span>
              </el-menu-item>
              
              <el-submenu index="7" v-if="homeType == '0'&&sysRolePower!=null&&sysRolePower.length>0">
                <template slot="title">审批中心</template>
                <!--<el-menu-item index="7-1">企业认证</el-menu-item>
                <el-menu-item index="7-2">供应商入驻</el-menu-item>-->
                <el-menu-item index="7-3">应用上架</el-menu-item>
                <el-menu-item index="7-4">资格认证审批</el-menu-item>
                <el-menu-item index="7-5" @click="toPath('/bussin/tickets', '工单处理')">工单处理</el-menu-item>
                <el-menu-item index="7-6" @click="toPath('/bussin/invoiceAdmin', '开票管理')">开票管理</el-menu-item>
                <el-menu-item index="7-7" @click="toPath('/config/groups', '配置管理')">配置管理</el-menu-item>
                <el-menu-item index="7-8" @click="toPath('/config/settlement-info', '入驻信息')">入驻信息</el-menu-item>
               
              </el-submenu>
              <div style="height: 200px;background-color: #fff;"></div>
            </el-menu>
          </el-aside>
        </div>
      </div>
    </div>
    <div class="right_box" style="font-size: 14px;">
      <div class="hread">
        <div class="hread_body">
          <div class="group03_text1">
            <div class="box_auth2">
              <div class="sec_text2">
                <!--<div class="box0_text1">
                  <span @click="toHomeType('/appUP/supplierHome')" :style="homeType=='1'?'color: #ff751d;':''">
                    {{'供应商后台'}} </span>
                </div>-->
              </div>
            </div>
          </div>
          <div class="group03_text">
            <div class="box_auth2">
              <div class="sec_text2">
                <div v-for="(itme, index) in muData" :key="index" class="box0_text1" :class="{'menu-item': itme.name !== 'homeType'}">
                  <span v-if="itme.name != 'homeType'" @click="toPath(itme.path,itme.name)">
                    <span :class="{'message-text': itme.name === '消息' && unreadCount > 0}">{{ itme.name }}</span>
                    <span v-if="itme.name === '消息' && unreadCount > 0" class="unread-badge">({{ unreadCount }})</span>
                  </span>
                  <!--<span v-else @click="toHomeType('/auth/userHome')" :style="homeType=='0'?'color: #ff751d;':''">
                    {{ '控制中心' }} </span>-->
                  <span class="pro20001" v-if="itme.isMudata.length > 0"><i class="el-icon-arrow-down"></i></span>
                  <span class="pro20002" v-if="itme.isMudata.length > 0"><i class="el-icon-arrow-up"></i></span>
                  <div class="child2" v-if="itme.isMudata.length > 0">
                    <div style=""
                      :style="itme.isMudata.length > 0 ? '' : ''">
                      <div style="margin-top: 0px" v-for="(it, ind) in itme.isMudata" :key="ind">
                        <div class="pro201" @click="toPath(it.path,it.name)" v-if="itme.name != 'homeType'">
                          {{ it.name }} <br />
                          <div v-if="it.hot == '1'" id="hot"
                            style="font-weight: normal;position: absolute;margin-top: -32px; margin-left: 85px;color: #ff751d;">
                            <span style="--i:1">h</span><span style="--i:2">o</span><span style="--i:3">t</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span  @click="toConnect(199, 'account')">
              <img :src="avatarSrc" alt="头像" class="img02" />
            </span>
         
          </div>
        </div>
      </div>
      <el-main style="margin-top: 82px; padding: 20px; background-color: #f0f2f5; min-height: calc(100vh - 82px);">
        <transition name="fade" mode="out-in">
          <div v-if="isNavigating" key="loading" class="loading-container">
            <el-loading-spinner></el-loading-spinner>
            <p>正在跳转...</p>
          </div>
          <component v-else-if="currentView === 'userAuth'" :is="'userAuth'"></component>
          <component v-else-if="currentView === 'roleManagement'" :is="'roleManagement'"></component>
          <component v-else-if="currentView === 'deptManagement'" :is="'deptManagement'"></component>
          <router-view v-else :key="$route.fullPath" />
        </transition>
      </el-main>
    </div>
  </div>
</template>
<script>
import {
  system_url,file_url
} from '@/api/baseUrl';
import { getUnreadMessageCount } from '@/api/task';
import UserAuth from '@/views/auth/userAuth';
import RoleManagement from '@/views/auth/roleManagement';
import DeptManagement from '@/views/auth/deptManagement';

export default {
  name: 'Home',
  data() {
    return {
      muData: [
        {
          name: '应用商城',
          hot: '0',
          path: '/productAll',
          leftPx: 'padding-left:340px;',
          isMudata: [
          ],
        }, 
        /*{
          name: 'homeType',
          hot: '0',
          path: '/',
          leftPx: 'padding-left:340px;',
          isMudata: []
        },*/
        {
          name: '财务中心',
          hot: '0',
          path: '',
          leftPx: 'padding-left:462px;',
          isMudata: [
            { name: '支付', hot: '0', path: '/auth/myPayment', 'content': '' },
            { name: '发票', hot: '0', path: '/auth/myInvoice', 'content': '' },
          ]
        },
        {
          name: '工单',
          hot: '0',
          path: '/auth/taskTickets',
          leftPx: 'padding-left:340px;',
          isMudata: []
        },
        {
          name: '消息',
          hot: '0',
          path: '/auth/messages',
          leftPx: 'padding-left:340px;',
          isMudata: []
        },
        /*{
          name: '帮助',
          hot: '0',
          path: '',
          leftPx: 'padding-left:340px;',
          isMudata: [
            { name: '我的工单', hot: '0', path: '/publicPage', 'content': '' },
            { name: '供需管理', hot: '0', path: '/publicPage', 'content': '' },
            { name: '开放平台', hot: '0', path: '/publicPage', 'content': '' },
            { name: '询价管理', hot: '0', path: '/publicPage', 'content': '' },
            { name: '建议反馈', hot: '0', path: '/publicPage', 'content': '' },
            { name: '帮助文档', hot: '0', path: '/publicPage', 'content': '' },
          ]
        },*/
      ],
      orderList:[
        {"name":"工单"},
        {"name":"售前咨询"},
        {"name":"售后咨询"},
        {"name":"提交工单"},
        {"name":"我的工单"},
      ],
      homeType:'0',
      activeNum: Boolean(localStorage.getItem("activeNum"))?localStorage.getItem("activeNum"):"1",
      userName: '',
      auth: '0',
      user: {},
      sysRolePower: [],
      supplierInfo: {},
      company: {},
      userAvatarPath:file_url+system_url,
      unreadCount: 0,
      currentView: '',
      messageTimer: null,
      isNavigating: false
    }
  },
  components: {
    'userAuth': UserAuth,
    'roleManagement': RoleManagement,
    'deptManagement': DeptManagement
  },
  mounted(){
    this.recordActiveFn();
  },
  created() {
    if (Boolean(localStorage.getItem("activeNum")) && localStorage.getItem("activeNum") != '' && localStorage.getItem("activeNum") != 'null') {
      this.activeNum = localStorage.getItem("activeNum");
    } else {
      this.recordActiveFn();
    }
    let path = window.location.href;
    if (path.indexOf("/auth/userHome") > -1) {
      this.homeType = "0";
    } 
    if (path.indexOf("/appUP/supplierHome") > -1) {
      this.homeType = "1";
    } 
    
    // 根据当前路径设置currentView
    if (path.indexOf("/auth/userAuth") > -1 || path.indexOf("/auth/userHome") > -1) {
      this.currentView = 'userAuth';
    } else if (path.indexOf("/auth/role-management") > -1) {
      this.currentView = 'roleManagement';
    } else if (path.indexOf("/auth/dept-management") > -1) {
      this.currentView = 'deptManagement';
    } else {
      this.currentView = '';  // 空字符串时显示router-view
    }
    
    this.user= Boolean(localStorage.getItem("userdata"))?JSON.parse(localStorage.getItem("userdata")):{};
    this.sysRolePower= Boolean(localStorage.getItem("sysRolePower"))?JSON.parse(localStorage.getItem("sysRolePower")):[];
    this.supplierInfo= Boolean(localStorage.getItem("supplierInfo"))?JSON.parse(localStorage.getItem("supplierInfo")):{};
    this.company= Boolean(localStorage.getItem("company"))?JSON.parse(localStorage.getItem("company")):{};
    
    // 初始获取未读消息数量
    this.getUnreadMessageCount();
    // 设置定时器，每5秒检查一次未读消息数量
    this.messageTimer = setInterval(this.getUnreadMessageCount, 30000);
  },
  watch: {
    // 监听路由变化
    '$route'(to, from) {
      console.log('路由变化:', to.path, 'from:', from.path);
      // 重置导航状态
      this.isNavigating = false;
      
      // 如果跳转到account/index或其他需要router-view的路由，确保currentView为空
      if (to.path === '/account/index' || to.path.startsWith('/auth/') || to.path.startsWith('/appUP/')) {
        this.currentView = '';
      }
    }
  },
  methods: {
    toConnect() {
      this.isNavigating = true; // 开始导航
      this.activeNum = '2';
      this.currentView = ''; // 重置currentView，确保router-view可见
      localStorage.setItem("activeNum", "2");
      
      // 使用$nextTick确保状态更新完成后再进行路由跳转
      this.$nextTick(() => {
        this.$router.push("/account/index").then(() => {
          this.isNavigating = false; // 导航完成
        }).catch(() => {
          this.isNavigating = false; // 导航失败也要重置状态
        });
      });
    },
    toHomeType(path){
      this.activeNum = '1';
      path == '/appUP/supplierHome'?this.homeType='1':this.homeType='0';
      localStorage.setItem("homeType", this.homeType);
      this.$router.push(path);
    },
    select(index, indexPath) {
      console.log(index,indexPath)
      if (index === "1") {
        this.currentView = '';
        this.$router.push("/auth/userHome");
        localStorage.setItem("activeNum", "1");
      }else if (index === "2") {
        this.currentView = '';
        this.$router.push("/auth/widget");
        localStorage.setItem("activeNum", "2");
      }  else if (index === "3") {
        this.currentView = '';
        this.$router.push("/publicPage");
        localStorage.setItem("activeNum", "3");
      } else if (index === "4") {
        this.currentView = '';
        this.$router.push("/publicPage");
        localStorage.setItem("activeNum", "4");
      } else if (index === "2") {
        this.currentView = 'userAuth';
        localStorage.setItem("activeNum", "2");
      } else if (index === "2-1") {
        this.currentView = '';
        this.$router.push("/auth/userAuth");
        localStorage.setItem("activeNum", "2-1");
      } else if (index === "2-2") {
        this.currentView = '';
        localStorage.setItem("activeNum", "2-2");
        this.$router.push("/auth/qualification-certification");
      } else if (index === "2-3") {
        this.currentView = 'roleManagement';
        localStorage.setItem("activeNum", "2-3");
      } else if (index === "2-4") {
        this.currentView = 'deptManagement';
        localStorage.setItem("activeNum", "2-4");
      } else if (index === "3-1") {
        this.currentView = '';
        this.$router.push("/auth/ticketsSupplierPersonal");
        localStorage.setItem("activeNum", "3-1");
        // 强制组件重新渲染
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      } else if (index === "3-2") {
        this.currentView = '';
        this.$router.push("/auth/ticketsSupplierCompany");
        localStorage.setItem("activeNum", "3-2");
        // 强制组件重新渲染
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      } else if (index === "7-1") {
        this.currentView = '';
        this.$router.push("/sysConfig/sysCompany"); 
        localStorage.setItem("activeNum", "7-1");
      } else if (index === "7-2") {
        this.currentView = '';
        this.$router.push("/sysConfig/sysSupplier"); 
        localStorage.setItem("activeNum", "7-2");
      } else if (index === "7-3") {
        this.currentView = '';
        this.$router.push("/sysConfig/sysApp"); 
        localStorage.setItem("activeNum", "7-3");
      } else if (index === "7-4") {
        this.currentView = '';
        this.$router.push("/bussin/certification-approval");
        localStorage.setItem("activeNum", "7-4");
      } else if (index === "6-1") {
        this.currentView = '';
        this.$router.push("/appUP/appMG");
        localStorage.setItem("activeNum", "6");
      } else if (index === "8") {
        this.currentView = '';
        this.$router.push("/appUP/orderMG");
        localStorage.setItem("activeNum", "8");
      } else if (index === "5") {
        this.currentView = '';
        this.$router.push("/application/appManage");
        localStorage.setItem("activeNum", "5");
      }
    },
    open() {
      this.$refs.child.handleOpen();
    },

    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    },
    toLogin() {
      localStorage.clear();
      localStorage.removeItem("userdata");
      this.$store.commit("logout", "false");
      this.$router.push({ path: '/login' });
    },
    toPath(path,type) {
      // 重置currentView，确保router-view可见
      this.currentView = '';
      if (path == '4042') {
        this.$message({
          type: "info",
          message: "系统正在开发中。。。",
        });
      } else {
        if (type == '订单管理') {
          localStorage.setItem("publicPage", "订单管理");
          this.$router.push({ path: path });
          setTimeout(() => {
            window.location.reload();
          }, 500)
        } else if (type == '发票') {
          localStorage.setItem("publicPage", "发票管理");
          this.$router.push({ path: path });
          // setTimeout(() => {
          //   window.location.reload();
          // }, 500)
        } else if (type == '续费管理') {
          localStorage.setItem("publicPage", "续费管理");
          this.$router.push({ path: path });
          setTimeout(() => {
            window.location.reload();
          }, 500)
        } else if (type == '合同管理') {
          localStorage.setItem("publicPage", "合同管理");
          this.$router.push({ path: path });
          setTimeout(() => {
            window.location.reload();
          }, 500)
        } else if (type == '我的工单') {
          localStorage.setItem("publicPage", "我的工单");
          this.$router.push({ path: path });
          setTimeout(() => {
            window.location.reload();
          }, 500)
        } else if (type == '供需管理') {
          localStorage.setItem("publicPage", "供需管理");
          this.$router.push({ path: path });
          setTimeout(() => {
            window.location.reload();
          }, 500)
        } else if (type == '开放平台') {
          localStorage.setItem("publicPage", "开放平台");
          this.$router.push({ path: path });
          setTimeout(() => {
            window.location.reload();
          }, 500)
        } else if (type == '询价管理') {
          localStorage.setItem("publicPage", "询价管理");
          this.$router.push({ path: path });
          setTimeout(() => {
            window.location.reload();
          }, 500)
        } else if (type == '建议反馈') {
          localStorage.setItem("publicPage", "建议反馈");
          this.$router.push({ path: path });
          setTimeout(() => {
            window.location.reload();
          }, 500)
        } else if (type == '帮助文档') {
          localStorage.setItem("publicPage", "帮助文档");
          this.$router.push({ path: path });
          setTimeout(() => {
            window.location.reload();
          }, 500)
        } else {
          this.$router.push({ path: path});
        }
      }
    },
    recordActiveFn() {
      let path = window.location.href;
      if (path.indexOf("/auth/userAuth") > -1) {
        this.activeNum = "2";
      } else if (path.indexOf("/auth/userHome") > -1) {
        this.activeNum = "1";
      } else if (path.indexOf("/application/index") > -1) {
        this.activeNum = "3";
      } else if (path.indexOf("/application/productCollectManage") > -1) {
        this.activeNum = "4";
      }  else if (path.indexOf("/supplierProduct") > -1) {
        this.activeNum = "6-1";
      } else if (path.indexOf("/bussinessRZ") > -1) {
        this.activeNum = "7-1";
      } else if (path.indexOf("/gysRZ") > -1) {
        this.activeNum = "7-2";
      } else if (path.indexOf("/productSJ") > -1) {
        this.activeNum = "7-3";
      } else if (path.indexOf("/bussin/certification-approval") > -1) {
        this.activeNum = "7-4";
      } else if (path.indexOf("/config/groups") > -1) {
        this.activeNum = "7-7";
      } else if (path.indexOf("/publicPage") > -1) {
        this.activeNum = "8";
      } else if (path.indexOf("/chat/gpt") > -1) {
        this.activeNum = "9";
      } else if (path.indexOf("/data/console") > -1) {
        this.activeNum = "10";
      }
    },
    // 获取未读消息数量
    getUnreadMessageCount() {
      getUnreadMessageCount()
        .then(res => {
          if (res.code === 200) {
            this.unreadCount = res.data || 0;
          } else {
            console.error('获取未读消息数量失败:', res.msg);
          }
        })
        .catch(error => {
          console.error('获取未读消息数量失败:', error);
        });
    },
    
    // 跳转到消息或工单页面
    toMessageOrTicket(path) {
      this.currentView = '';
      this.$router.push(path);
    },
  },
  beforeUpdate() { },
  beforeDestroy() {
    // 在组件销毁前清除定时器
    if (this.messageTimer) {
      clearInterval(this.messageTimer);
    }
  },
  computed: {
    avatarSrc() {
      return this.user.userAvatar ? this.userAvatarPath + '/zrUtil/showImg?path=' + this.user.userAvatar : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
    }
  }
}
</script>
<style>
/* 全局过渡效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

::-webkit-scrollbar {
  width: 0px;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
}

.el-dropdown-menu__item, .el-menu-item {
    font-size: 16px;
    padding: 0 20px;
    cursor: pointer;
    font-weight: 400;
}
.el-submenu__title {
    font-size: 16px;
    color: #303133;
    font-weight: 400;
}
</style>
<style scoped>
.group03_text1{

}
.box0_text1 {
  font-weight: 400;
  cursor: pointer;
  width: 70px;
  font-size: 14px;
  /* padding: 0px 20px; */
}

/* 菜单项样式 */
.menu-item {
  width: auto;
  margin-right: 5px;
  padding: 0 3px;
  display: inline-flex;
  align-items: center;
}

.box0_text1:hover {
  color: #ff751d;
}
.box0_text1:hover .child2 {
  display: block;
}
.box0_text1:hover .pro20001 {
  display: none;
}

.box0_text1:hover .pro20002 {
  display: unset;
}

.pro20001 {
  display: unset;
  /* 
  margin-left: 82px;
  position: absolute;
  margin-top: -15px;
  width: 10px;
  height: 10px; */
}

.pro20002 {
  display: none;
  /* position: absolute;
  margin-top: -15px;
  margin-left: 82px;
  width: 10px;
  height: 10px; */
}

.child2 {
  display: none;
  /* width: 100%; */
  /* width: 96px; */
  position: fixed;
  padding-bottom: 35px;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  z-index: 290;
  /* right: 0px; */
  /* margin-left: 10px; */
  top: 42px;
  cursor: unset;
}


.pro201022{
  margin-top: 20px;
  font-weight: 400;
  padding-left: 26px;
  padding-right: 26px;
  /* text-align: center; */
  /* width: 100%; */
  color: #666666;
}
.pro2010222{
  color: #666666;
  line-height: 36px;
  font-weight: 100;
  display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	word-wrap: break-word;
	white-space: normal !important;
	-webkit-line-clamp: 1;/* 控制在第几行进行加省略号 */
	-webkit-box-orient: vertical;
}
.pro2010222:hover {
  color: #ff751d;
}

.pro201 {
  margin-top: 20px;
  font-weight: 400;
  padding-left: 26px;
  padding-right: 26px;
  /* text-align: center; */
  /* width: 100%; */
  color: #666666;
}

.pro201:hover {
  color: #ff751d;
}

.el-menu {
  border: 0px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 250px;
  min-height: 400px;
}

.page {
  width: 100%;
  display: flex;
  color: #000;
}

.left_box {
  width: 260px;
  height: 100vh;
  box-shadow: 4px 4px 16px 4px rgba(75, 88, 108, .16);
}

.block {
  height: 100vh;
  width: 240px;
  margin: auto;
}

.group01 {
  height: 70px;
  width: 240px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}

.img01 {
  /* height: 60px;
  width: 60px;
  border-radius: 50%; */
  width: 180px;
}

.text01 {
  font-size: 26px;
  font-family: "Lucida Calligraphy", cursive, serif, sans-serif;
}

.group02 {
  height: calc(100vh - 100px);
  width: 240px;
}

.connect {
  width: 220px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #0069fe;
  font-size: 16px;
  color: white;
  height: 50px;
  border-radius: 8px;
  margin-left: 5px;
}

.box_name:hover {
  color: #0069fe;
}

.box_auth2 {
  margin-right: 20px;
}

.box_auth {
  background-color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 150px;
}


.connect1 {
  width: 220px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  height: 50px;
  margin-left: 5px;
}

.hot {
  padding: 1px 4px 1px 4px;
  position: absolute;
  color: white;
  background-color: red;
  border-radius: 6px;
  margin-top: 30px;
  font-size: 14px;
  margin-left: 100px;
}

.group04 {
  margin-top: 20px;
  height: 10px;
  width: 240px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 30px;
}

.group03 {
  width: 240px;
  font-size: 18px;
  position: fixed;
  bottom: 24px;
}

.group03_text {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px; /* 从15px减少到10px */
}

.sec_group {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}

.sec_text2 {
  text-align: center;
  cursor: pointer;
  /* width: 170px; */
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 15px;
  color: #666666;
  gap: 5px; /* 从10px减少到5px */
}
/* 
.sec_text2:hover {
  color: #55aafe;
} */

.img02 {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  margin-right: 20px;
  margin-left: 0;
  cursor: pointer;
}

.right_box {
  width: calc(100% - 260px);
  height: 100vh;
  overflow-y: auto;
  /* background-color: #e6f1ff; */
  background-color:  #f0f2f5;;
}

/* 设置动画 */
@keyframes donghua {
  0% {
    transform: translateY(0px);
  }

  20% {
    transform: translateY(-3px);
  }

  40%,
  100% {
    transform: translateY(0px);
  }
}

#text span {
  /* 设置行内块元素 */
  display: inline-block;
  /* 添加动画 */
  animation: donghua 1.5s ease-in-out infinite;
  /* 利用变量动态计算动画延迟时间 */
  animation-delay: calc(.1s*var(--i));
}
.hread{
  height: 72px;
  background-color: #fff;
  position: fixed;
  top: 0;
  margin-bottom: 80px;
  box-shadow: 0 8px 35px -24px rgba(0, 36, 100, .5);
  width: calc(100% - 260px);
  z-index: 100;
}
.hread_body {
  /* padding: 0 32px; */
  box-shadow: 4px 4px -4px 4px rgba(0, 36, 100, .16);
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 15px; /* 添加右侧内边距 */
}
.unread-badge {
  color: #f56c6c;
  font-weight: bold;
  margin-left: 3px;
}

.message-text {
  color: #f56c6c;
  font-weight: bold;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #666;
}

.loading-container p {
  margin-top: 10px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue